/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const textFieldLabelFrom = 'From';
export const textFieldLabelTo = 'To';
export const rebateProgramLable = 'Rebate Program';
export const showMyAuditsOnlyLable = 'Show My Audits Only';
export const unreversedLable = 'Unreversed';
export const reversedLable = 'Reversed';
export const includeClearedAuditsLabel = 'Include Cleared Audits';
export const selectByLabel = 'Select By';
export const auditTypeLabel = 'Audit Types';
export const amountAuditLabel = 'Amount/Unit Audits ';
export const unitConversionAuditsLabel = 'Unit Conversion Audits';
export const otherAuditsLabel = 'Other Audits';
export const labelerGridFileName = 'labeler Data';
export const viewClaimDetailButton = 'View Claim Detail';
export const confirm = 'Confirm';
export const navigate = '/claimAuditSelect';
